// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { QuickRfqApiParameter, QuickRfqModal, SubmitQuickRfqFormService } from "@awc/App/Services/CustomForms";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type HandlerType = ApiHandler<
    QuickRfqApiParameter & HasOnSuccess<ServiceResult<QuickRfqModal>> & HasOnError<string>,
    ServiceResult<QuickRfqModal>
>;

export const PopulateApiParameters: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await SubmitQuickRfqFormService(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameters, RequestDataFromApi, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const SubmitQuickRfqForm = createHandlerChainRunner(chain, "SubmitQuickRfqForm");

export default SubmitQuickRfqForm;
